function hideNotApplicableVariants() {
  document.querySelectorAll('.variant-radio-label').forEach(label => {
    if (label.textContent.trim() === 'Not Applicable') {
      label.style.display = 'none';

      const input = label.querySelector('input');
      if (input) {
        input.disabled = true;
      }
    }
  });
}

hideNotApplicableVariants();

const variantObserver = new MutationObserver(() => {
  hideNotApplicableVariants();
});

variantObserver.observe(document.body, {
  childList: true,
  subtree: true
});